export const LISTEN_WHILE_YOU_WORK = "Listen while you work";

export const HERES_HOW_IT_WORKS = "Here’s how it works";

export const LISTENING_TO_AND =
  "Listening to and acting on your feedback is one of the ways we continue to make Amazon a safe place to work, and we’re always looking for ways to make improvements where we can.";

export const THANKS_TO_NEW =
  "Thanks to new safety-centric technology, associates in select process paths at eligible sites are able to trial new state-of-the-art headphones to safely listen to audio content while working.";

export const AMAZONS_PERSONAL_HEADPHONE =
  "Amazon’s Personal Headphone Program is a voluntary program that allows Amazon associates within safe process paths to listen to music, audiobooks, podcasts, or any other audio file while at work on pre-approved headphones at work. At this time, only select sites are eligible to participate in this program. In addition to site eligibility, the headphones can only be worn in specific process paths.";

export const CHECK_YOUR_ELIGIBILITY = "Check your eligibility.";
export const CHECK_YOUR_ELIGIBILITY_CONTENT =
  "Amazon associates are eligible for Amazon’s Personal Headphone Program. They can use approved headphones to listen to music, audiobooks, podcasts, or any other audio file while in designated process paths. At this time, only select sites are eligible to participate in this program.";

export const LEARN_THE_SAFETY_RULES = "Learn the safety rules.";
export const LEARN_THE_SAFETY_RULES_CONTENT =
  "These rules must be followed at all times when wearing the approved headphones.";
export const LEARN_THE_SAFETY_RULES_BULLETPOINTS = [
  "only_use_in_the",
  "always_pay_attention",
  "follow_the_mobile",
  "do_not_attach_headphones",
  "headphones_are_not",
  "do_not_use_headphones",
];

export const EXPLORE_YOUR_OPTIONS = "Explore your options.";
export const EXPLORE_YOUR_OPTIONS_CONTENT =
  "There are two headphone options available for purchase based on safety volume standards: Plugfones Freereign VL and Elgin Discord Limited. These are the only headphones allowed on the floor.";

export const INELIGIBLE_SITE_MESSAGE =
  "Your location is not eligible to participate at this time. ";

export const ELIGIBLE_PROCESS_MESSAGE =
  "Great, your selected process path is eligible!";

export const INELIGIBLE_PROCESS_MESSAGE =
  "Unfortunately this process path is not currently eligible";

export const PURPOSE = "Purpose";
export const PURPOSE_PARAGRAPH =
  "This policy allows T1 hourly associates to use Amazon approved Personal Headphones to listen to music, audiobooks, podcasts, or any other audio file while at work, keeping associate safety as the highest priority. ";

export const APPLICABILITY = "Applicability";
export const APPLICABILITY_PARAGRAPH =
  "This policy is applicable in the US and Canada, at selected process paths in specific Amazon locations. Check the eligibility section for further information. This policy is not intended to supersede or replace any applicable regulatory requirements nor existing Amazon standards, including Amazon’s Mobile phone policy, which prohibits the use of cellphones to make audio or visual calls, except in designated areas or while on break.";

export const ELIGIBILITY = "Eligibility";
export const ELIGIBILITY_PARAGRAPH =
  "All classes of non-exempt, T1 hourly employees who work in approved process paths at approved sites are eligible for this policy. Contact your manager with any questions to learn more regarding eligibility.";

export const OVERVIEW_DO = [
  "Restrain cords at all times by tucking into clothing",
  "Secure device in a pocket when not in use",
];

export const REVIEW_POLICY = "Review Policy";

export const POLICY_TITLE =
  "Policy: Amazon Approved Headphones Use – CAN and US";

export const OVERVIEW_DONT = [
  "Leave personal headphones out on working surfaces or on the floor.",
  "Affix/attach personal headphones to body, clothing or accessories (e.g. lanyard, knot around neck, through earrings etc.)",
];

export const AMAZON_DOES_NOT_PERMIT_THE_FOLLOWING = [
  "Use of non-approved headphones or ear buds.",
  "Use of any headphones while driving, operating, or around vehicles.",
  "Use of any headphones while in the truck yard, ramp, parking lots or tarmac.",
  "Use of any headphones in PIT lanes or areas or while on or participating in PIT operations.",
  "Use of any headphones while walking across process paths and in pedestrian walkways.",
  "Use of any headphones in areas that are not approved for headphones usage.",
];

export const PRODUCT_TEXTS = [
  {
    HEADING: "Plugfone Freereign VL",
    DESCRIPTION:
      "The Plugfone Freereign VL, designed for Amazon employees, is tested and compliant with ANSI standards and meets NIOSH criteria.",
    LONG_DESCRIPTION:
      "The most important thing to remember about Plugfones is that they’re earplugs first and earbuds second. As such, the entire Plugfones line is tested and compliant with ANSI S3.19-1974 noise reduction standards and meets NIOSH criteria. When used as directed, our products are certified for Noise Reduction Ratings (NRR) of 29 or 27 dB, depending on the plugs used. For environments with high levels of noise, it may be necessary to use over ear protection such as earmuffs in conjunction with Plugfones products.",
    BULLET_POINTS: [
      "$33.50",
      "Hearing protection with a certified noise reduction rating of 27 decibels",
      "Volume limit of 82 decibels",
      "Up to 12 hours of listening with a single charge",
      "A custom ear hook feature designed by Amazon employees to help with wearability",
    ],
  },
  {
    HEADING: "Elgin Discord Limited",
    DESCRIPTION:
      "The Elgin Discord Limited, designed for Amazon employees, is EPA-certified to meet ANSI standards.",
    LONG_DESCRIPTION:
      "Elgin’s Discord Volume-Limited bluetooth earplug earbuds are purpose-built for noisy, rigorous work environments where long hours and heavy use are the norm. EPA certified to meet ANSI standards, Discord Limited earbuds provide hearing protection with a 25 dB Noise Reduction Rating (NRR) and 82 dB volume limit.",
    BULLET_POINTS: [
      "$49.78",
      "Hearing protection with a certified noise reduction rating of 25 decibels",
      "Volume limit of 82 decibels",
      "Up to 14 hours of listening with a single charge",
      "Weatherproof design to block out dust and sweat",
    ],
  },
];

export const FAQs = [
  [
    "how_do_i_purchase",
    "once_you_have_reviewed",
    "once_you_have_reviewed_2",
    "once_you_have_reviewed_3",
  ],
  ["what_if_i_have", "for_headphone_issues"],
  ["can_i_use", "no_only_amazon_approved"],
  ["i_am_not", "if_you_are", "If_you_are_2"],
  ["who_do_i_talk", "if_you_have_questions"],
];

export const FEATURES = [
  {
    title: "connection_type",
    values: ["connection_type_plugfones", "connection_type_elgin", "connection_type_plugfones_sovereign", "connection_type_plugfones_mercenary_lt", "connection_type_plugfones_allert"],
  },
  {
    title: "battery_life",
    values: ["battery_life_plugfones", "battery_life_elgin", "battery_life_plugfones_sovereign", "battery_life_plugfones_mercenary_lt", "battery_life_plugfones_allert"],
  },
  {
    title: "hearing_protection",
    values: ["hearing_protection_plugfones", "hearing_protection_elgin", "hearing_protection_plugfones_sovereign", "hearing_protection_plugfones_mercenary_lt", "hearing_protection_plugfones_allert"],
  },
  {
    title: "durability",
    values: ["durability_plugfones", "durability_elgin", "durability_plugfones_sovereign", "durability_plugfones_mercenary_lt", "durability_plugfones_allert"],
  },
  {
    title: "ear_tip_options",
    values: ["ear_tip_options_plugfones", "ear_tip_options_elgin", "ear_tip_options_plugfones_sovereign", "ear_tip_options_plugfones_mercenary_lt", "ear_tip_options_plugfones_allert"],
  },
  {
    title: "warranty",
    values: ["warranty_plugfones", "warranty_elgin", "warranty_plugfones_sovereign", "warranty_plugfones_mercenary_lt", "warranty_plugfones_allert"],
  },
  {
    title: "charger_type",
    values: ["charger_type_plugfones", "charger_type_elgin", "charger_type_plugfones_sovereign", "charger_type_plugfones_mercenary_lt", "charger_type_plugfones_allert"],
  },
  {
    title: "additional_hardware_included",
    values: [
      "additional_hardware_included_plugfones",
      "additional_hardware_included_elgin",
      "additional_hardware_included_plugfones_sovereign",
      "additional_hardware_included_plugfones_mercenary_lt",
      "additional_hardware_included_plugfones_allert"
    ],
  },
  {
    title: "weatherproof",
    values: ["✔", "✔", "✔", "✔", "✔"],
  },
];

export const ELIGIBLE_PRODUCTS_HEADER = "Compare eligible products";
export const PLUGFONES_TITLE = "Plugfones FreeReign VL";
export const PLUGFONES_ALLERT_TITLE = "Plugfones Allert VL";
export const ELGIN_TITLE = "Elgin Discord Limited";
export const PLUGFONES_SOVEREIGN_TITLE = "Plugfones Sovereign VL";
export const PLUGFONES_MERCENARY_LT_TITLE = "Plugfones Mercenary LT";